import { cn } from "../../../lib/cn";

/**
 * AreaFilter — filtro tipo "tab pill".
 *
 * Off: gris claro. On: navy oscuro con texto blanco.
 * Acepta contador opcional.
 */

export function AreaFilter({ active, count, children, onClick, className }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-pill",
        "text-xs font-medium transition-colors",
        active
          ? "bg-slate-900 text-white"
          : "bg-slate-100 text-slate-600 hover:bg-slate-200",
        className,
      )}
    >
      {children}
      {typeof count === "number" && (
        <span className={cn("text-[11px]", active ? "text-slate-300" : "text-slate-400")}>
          ({count})
        </span>
      )}
    </button>
  );
}
